import { render, staticRenderFns } from "./df-page-account-coupon-savi.vue?vue&type=template&id=34573ade&scoped=true"
import script from "./df-page-account-coupon-savi.ts?vue&type=script&lang=js&external"
export * from "./df-page-account-coupon-savi.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34573ade",
  null
  
)

export default component.exports